<template>
    <div class="ed video-tree">
        <el-form  ref="formRef" label-width="110px" size="mini" :inline="true" >
            <el-form-item class="mf form-title"  label="班次" >
                <el-input  v-model="formData.vc_bcname"  style="width:140px">
                </el-input>
            </el-form-item>
            <el-form-item class="mf form-title"  label="班次类别" >
                <el-select  v-model="formData.i_type" placeholder="请选择" style="width:140px" filterable required  >
                    <el-option
                            v-for="one in typeList"
                            :key="one.id"
                            :label="one.vc_name"
                            :value="one.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item class="mf form-title"  label="是否出勤" >
                <el-select  v-model="formData.i_iswork" placeholder="请选择" style="width:140px" filterable required  >
                    <el-option
                            v-for="one in workList"
                            :key="one.id"
                            :label="one.vc_name"
                            :value="one.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item class="mf form-title"  label="是否四分段" >
                <el-select  v-model="formData.i_isfourth" placeholder="请选择" style="width:140px" filterable required  >
                    <el-option
                            v-for="one in i_isfourthList"
                            :key="one.id"
                            :label="one.vc_name"
                            :value="one.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item class="mf form-title"  label="出勤标识" >
                <el-input  v-model="formData.vc_bcnote"  style="width:140px">
                </el-input>
            </el-form-item>
<!--            <div class="item">-->
                <el-form-item  class="form-title"  label="工作时间(上)" >
                    <el-time-select
                            placeholder="起始时间"
                            v-model="formData.upbegintime"
                            :picker-options="{
                              start: '00:00',
                              step: '00:30',
                              end: '24:00'
                            }"
                            @change="changeup1">
                    </el-time-select>
                    <el-time-select
                            v-if="formData.i_isfourth==1"
                            style="margin-left: 10px;"
                            placeholder="中间时间"
                            v-model="formData.vc_upperbetween"
                            :picker-options="{
                              start: '00:00',
                              step: '00:30',
                              end: '24:00',

                            }"
                            @change="changeup3">
                    </el-time-select>
                    <el-time-select
                            style="margin-left: 10px;"
                            placeholder="结束时间"
                            v-model="formData.upendtime"
                            :picker-options="{
                              start: '00:00',
                              step: '00:30',
                              end: '24:00',

                            }"
                            @change="changeup2">
                    </el-time-select>
                    <span style="margin-left: 10px">{{'时长'+this.formData.i_upperhour+' h'}}</span>
                </el-form-item>
<!--            </div>-->
<!--            <div class="item">-->
                <el-form-item   class="form-title"  label="工作时间(下)" >
                    <el-time-select
                            style=""
                            placeholder="起始时间"
                            v-model="formData.downbegintime"
                            :picker-options="{
                              start: '00:00',
                              step: '00:30',
                              end: '24:00'
                            }"
                            @change="changedown1">
                    </el-time-select>
                    <el-time-select
                            v-if="formData.i_isfourth==1"
                            style="margin-left: 10px;"
                            placeholder="中间时间"
                            v-model="formData.vc_lowerbetween"
                            :picker-options="{
                              start: '00:00',
                              step: '00:30',
                              end: '24:00',

                            }"
                            @change="changedown3">
                    </el-time-select>
                    <el-time-select
                            style="margin-left: 10px;"
                            placeholder="结束时间"
                            v-model="formData.downendtime"
                            :picker-options="{
                              start: '00:00',
                              step: '00:30',
                              end: '24:00',

                            }"
                            @change="changedown2">
                    </el-time-select>
                    <span style="margin-left: 10px">{{'时长'+this.formData.i_lowerhour+' h'}}</span>
                </el-form-item>
<!--            </div>-->
            <el-form-item  label="岗位" class="mf form-title">
                <el-select  class="inputwidth" style="width:140px;" v-model="formData.vc_position" placeholder="请选择">
                    <el-option v-for="val in ceshi" :key="val.id" :label="val.name" :value="val.name"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item class="mf form-title"  label="考勤时长" >
                <el-input-number  style="width:140px;" :controls="false" :precision="2" :min="0" v-model.number="formData.f_attendance" >
                </el-input-number>
                <span style="margin-left: 10px">{{'小时'}}</span>
            </el-form-item>
            <el-form-item class="mf form-title"  label="打卡次数" >
                <el-select  v-model="formData.i_dknum" placeholder="请选择"  style="width:140px;"  @change="changeDKtimes" filterable required clearable >
                    <el-option
                            v-for="one in DKtimes"
                            :key="one.i_num"
                            :label="one.vc_name"
                            :value="one.i_num">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item class="mf form-title"  label="打卡时间" >
                <el-input-number  style="width:140px;" :controls="false" :precision="2" :min="0" v-model.number="formData.i_dktime" >
                </el-input-number>
                <span style="margin-left: 10px">{{'分钟'}}</span>
            </el-form-item>

        </el-form>
        <div slot="footer"  class="dialog-footer" style="text-align: center;margin-top: 25px">
            <el-button type="primary" @click="saveForm" :disabled="disabled" size="mini">{{$t('button_save')}}</el-button>
            <el-button @click="cancel" size="mini">{{$t('button_cancel')}}</el-button>
        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {mapActions} from "vuex";
    import {baseerp} from "@/utils/baseUrl";
    export default {
        name: "AddShift",
        props:{
            formvalue:{
                type:Object,
                required:true,
            },


            gaibianid:{
                type:Number,
                required:true
            },
            bianjiyonghu:{
                type:Object,
                required:true
            }
        },
        data() {
            return {
                downhours:0,
                uphours:0,
                DKtimes:[
                    {vc_name:"一次",i_num:1},
                    {vc_name:"两次",i_num:2},
                    {vc_name:"四次",i_num:4}
                ],
                baseerp:"",
                edit:false,
                formData:{
                    vc_lowerbetween:'',
                    i_lowerbetween:1,
                    i_upperbetween:1,
                    vc_upperbetween:'',
                    i_iswork:0,
                    i_type:0,
                    i_isfourth:1,
                    vc_bcname:'',
                    vc_bcnote:'',
                    vc_djmark:'',
                    upbegintime:'',
                    upendtime:'',
                    downbegintime:'',
                    downendtime:'',
                    i_upperhour:0,
                    i_lowerhour:0,
                    f_attendance:0,
                    i_dknum:0,
                    i_dktime:0,
                    i_id:0,
                    vc_lruname:'',
                    vc_position:'',
                    i_position:0,
            postData:[]
                },
                proname:"",
                formRules:{
                    /* wtname:[{required:true,message:"请选择委托公司",trigger:"change"}],
                     gsname:[{required:true,message:"请选择加工公司",trigger:"change"}],
                     cjname:[{required:true,message:"请选择车间",trigger:"change"}],
                     zdname:[{required:true,message:"请选择制定人",trigger:"change"}],
                     proname:[{required:true,message:"请选择产品",trigger:"change"}],
                     ckname:[{required:true,message:"请选择仓库",trigger:"change"}],
                     jgcost:[{required:true,message:"请输入加工费",trigger:"blur"}],
                     shul:[{required:true,message:"请输入数量",trigger:"blur"}],
                     endtime:[{required:true,message:"请选择结束日期",trigger:"change"}],
                     begintime:[{required:true,message:"请选择开始日期",trigger:"change"}],*/
                },
                wtcompanyName:[],
                companyName:[],
                groupName:[],
                personName:[],
                proList:[],
                warehouseName:[],
                gsid:0,
                ckid:0,
                pzid:0,
                cjid:0,
                i_id:0,
                i_type:9,
                wtgsid:0,
                zduid:0,
                pzname:"",
                zdname:"",
                wtname:"",
                gsname:"",
                cjname:"",
                lastTime:"",
                disabled:false,
                mid:0,
                setid:0,
                i_kqtcid:0,
                postid:0,
                ceshi:'',
                typeList:[{id:0,vc_name:'正常班次'},{id:1,vc_name:'休'},{id:2,vc_name:'调'}],
                workList:[{id:1,vc_name:'班'},{id:0,vc_name:'休'}],
                i_isfourthList:[{id:1,vc_name:'是'},{id:0,vc_name:'否'}],

            }
        },
        watch:{
            formvalue:{
                handler(){
                    if (this.formvalue) {
                        //this.disabled=false;
                        // console.log(this.formvalue)
                        this.formData.vc_djmark=this.formvalue.vc_djmark
this.i_kqtcid=this.formvalue.i_id
                    }
                },
                immediate:true,
                deep:true
            },


        },
        mounted() {
            this.positionlist()
            // console.log(this.formData,'123')
            // this.formData.vc_lruname=sessionStorage.getItem("lruname"),;
            this.baseerp=baseerp;
            // console.log("render",this.render);
            // console.log(this.formData.vc_note)
// if(this.bianjiyonghu)
            if(this.gaibianid==0){
                this.formData.vc_bcname=''
                    this.formData.vc_bcnote='',
                        // this.formData.vc_djmark=this.bianjiyonghu.vc_djmark,

                        // this.formData.vc_djmark=,
                    this.formData.upbegintime='',
                    this.formData.upendtime='',
                    this.formData.downbegintime='',
                    this.formData.downendtime='',
                    this.formData.i_upperhour=0,
                    this.formData.i_lowerhour=0,
                    this.formData.f_attendance=0,
                    this.formData.i_dknum=0,
                    this.formData.i_dktime=0,
                    this.formData.i_id=0,
                        this.formData.vc_position=''
                    this.formData.vc_lruname=this.bianjiyonghu.vc_lruname
                this.formData.postData=this.bianjiyonghu.postData
                // console.log(this.bianjiyonghu,'123')

                // console.log(this.formData.f_jobhours)

            }else {
                this.formData.vc_position=this.bianjiyonghu.vc_position
                this.formData.i_position=this.bianjiyonghu.i_position
                this.formData.postData=this.bianjiyonghu.postData
                this.formData.f_jobhours=parseFloat(this.bianjiyonghu.i_upperhour)+parseFloat(this.bianjiyonghu.i_lowerhour)

                            this.formData.vc_bcname=this.bianjiyonghu.vc_bcname,
                                this.formData.vc_bcnote=this.bianjiyonghu.vc_bcnote,
                                // this.formData.vc_djmark=this.bianjiyonghu.vc_djmark,
                                this.formData.upbegintime=this.bianjiyonghu.dt_upperstart,
                                this.formData.upendtime=this.bianjiyonghu.dt_upperend,
                                this.formData.downbegintime=this.bianjiyonghu.dt_lowerstart,
                                this.formData.downendtime=this.bianjiyonghu.dt_lowerend,
                                this.formData.i_upperstart=this.bianjiyonghu.i_upperstart,
                                this.formData.i_upperend=this.bianjiyonghu.i_upperend,
                                this.formData.i_lowerstart=this.bianjiyonghu.i_lowerstart,
                                this.formData.i_lowerend=this.bianjiyonghu.i_lowerend,
                                this.formData.vc_upperbetween=this.bianjiyonghu.vc_upperbetween,
                                this.formData.i_upperbetween=this.bianjiyonghu.i_upperbetween,
                                this.formData.vc_lowerbetween=this.bianjiyonghu.vc_lowerbetween,
                                this.formData.i_lowerbetween=this.bianjiyonghu.i_lowerbetween,
                                this.formData.i_upperhour=this.bianjiyonghu.i_upperhour,
                                this.formData.i_lowerhour=this.bianjiyonghu.i_lowerhour,
                                this.formData.f_attendance=this.bianjiyonghu.f_attendance,
                                this.formData.i_dknum=this.bianjiyonghu.i_dknum,
                                this.formData.i_dktime=this.bianjiyonghu.i_dktime,
                                this.formData.i_id=this.bianjiyonghu.i_id,
                                this.formData.i_iswork=this.bianjiyonghu.i_iswork,
                                this.formData.i_type=this.bianjiyonghu.i_type,
                                this.formData.i_isfourth=this.bianjiyonghu.i_isfourth,
                                this.formData.vc_lruname=this.bianjiyonghu.vc_lruname
                // console.log(this.bianjiyonghu,'1234')

            }
//             console.log(this.bianjiyonghu)
        },
        computed:{
            //禁止跨月
            /*pickerOptions(){
                let _this = this
                return {
                    disabledDate(time) {
                        let start = new Date(_this.lastTime);
                        start.setDate(start.getDate());
                        return time.getTime() > start.getTime();
                    }
                }
            }*/
        },
        methods: {
            ...mapActions(["getCurrentMenuId"]),
            //获取岗位列表

            async positionlist(){
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                };


                let param={

                }
                let res=await API.positionlist(param)
                if(res.code==1){
                    this.ceshi=res.data
                    // this.jobhour=val[0]+val[1]
                    // console.log(res.data,11)
                } else if (res.code == -2) {
                    this.$router.push('/login')
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                };
            },
            changeup1(val){
              // console.log("val1",val) ;
              // console.log("beg",this.formData.upbegintime,"end",this.formData.upendtime);
                if (this.formData.upendtime){
                    this.mathuptime(1);
                }else{
                    this.formData.i_upperhour=0;
                }
            },

            changeup2(val){

                if (this.formData.upbegintime){
                    this.mathuptime(1);
                }else{
                    this.$message.error("请先选择开始时间");
                    this.formData.upendtime="";
                    this.formData.i_upperhour=0;
                }
            },
            changeup3(val){

                if (this.formData.upbegintime){
                    let da=this.compareTime(this.formData.upbegintime,this.formData.vc_upperbetween);
                    if(da==1){
                        this.formData.i_upperbetween=2;
                    }else if(da==2){
                        this.formData.i_upperbetween=1;
                    }else{
                        this.$message.error("不能与开始时间相同");
                        this.formData.vc_upperbetween="";
                        this.formData.i_upperbetween=0;
                    }
                }else{
                    this.$message.error("请先选择开始时间");
                    this.formData.vc_upperbetween="";
                    this.formData.i_upperbetween=0;
                }
            },
            compareTime(time1,time2){
                let date1=new Date('01/01/2000 '+time1),
                    date2=new Date('01/01/2000 '+time2);
                if(date1>date2){
                    return 1
                }else if(date1<date2){
                    return 2
                }else{
                    return 0
                }
            },

            mathuptime(val){
                // console.log("val",val);
                let today=new Date().toLocaleDateString().split('/').map(item=>{if (item<10){return '0'+ item}else {return item}}).join('-');
                // console.log("today",today);
                if (val==1){
                    // console.log(1)
                    // console.log("beg",this.formData.upbegintime,"end",this.formData.upendtime);
                    let begintime= today+' '+this.formData.upbegintime;
                    let vc_upperbetween= today+' '+this.formData.vc_upperbetween;
                    let endtime= today+' '+this.formData.upendtime;
                    // console.log("begintime",begintime,"endtime",endtime);
                    var beginchangetime = (new Date(begintime)).getTime(); //得到毫秒数
                    var vc_upperbetweentime = (new Date(vc_upperbetween)).getTime(); //得到毫秒数
                    var endchangetime = (new Date(endtime)).getTime(); //得到毫秒数\
                    let millisecond = 1000 * 60 * 60 * 24;
                    var dateDiff=0
                    if(beginchangetime-endchangetime<0){
                         dateDiff =endchangetime- beginchangetime ; //时间差的毫秒数
                        // console.log(Math.abs(dateDiff),'222')
                        this.formData.i_upperstart=1
                        this.formData.i_upperend=1
                        this.formData.i_upperhour = parseFloat((dateDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)).toFixed(2);
                    }else if (beginchangetime-endchangetime>0){
                         dateDiff =  endchangetime-beginchangetime+millisecond ; //时间差的毫秒数
                        this.formData.i_upperstart=1
                        this.formData.i_upperend=2
                        this.formData.i_upperhour = parseFloat((dateDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)).toFixed(2);
                    }else if (beginchangetime-endchangetime==0){
                        this.formData.i_upperstart=1
                        this.formData.i_upperend=2
                        dateDiff=millisecond
                        // console.log(dateDiff,'555')
                        this.formData.i_upperhour = parseFloat(dateDiff  / (1000 * 60 * 60)).toFixed(2);
                    }
                }else if(val==2){
                    let begintime= today+' '+this.formData.downbegintime;
                    let vc_lowerbetween= today+' '+this.formData.vc_lowerbetween;
                    let endtime= today+' '+this.formData.downendtime;
                    var beginchangetime = (new Date(begintime)).getTime(); //得到毫秒数
                    var vc_lowerbetweentime = (new Date(vc_lowerbetween)).getTime(); //得到毫秒数
                    var endchangetime = (new Date(endtime)).getTime(); //得到毫秒数
                    let millisecond = 1000 * 60 * 60 * 24;
                    var dateDiff=0
                    if(beginchangetime-endchangetime<0){
                        this.formData.i_lowerstart=1
                        this.formData.i_lowerend=1
                        dateDiff =endchangetime- beginchangetime ; //时间差的毫秒数
                        this.formData.i_lowerhour = parseFloat((dateDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)).toFixed(2);
                    }else if (beginchangetime-endchangetime>0){
                        dateDiff =  endchangetime-beginchangetime+millisecond ; //时间差的毫秒数
                        this.formData.i_lowerstart=1
                        this.formData.i_lowerend=2
                        this.formData.i_lowerhour = parseFloat((dateDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)).toFixed(2);
                    }else if (beginchangetime-endchangetime==0){
                        dateDiff=millisecond
                        this.formData.i_lowerstart=1
                        this.formData.i_lowerend=2
                        this.formData.i_lowerhour = parseFloat(dateDiff  / (1000 * 60 * 60)).toFixed(2);
                    }
                }
                // console.log(parseFloat(this.formData.i_lowerhour),"this.formData.i_lowerhour",parseFloat(this.formData.i_upperhour));

                // if(parseFloat(this.formData.i_upperhour)==parseFloat(this.formData.i_lowerhour)){
                //     this.formData.f_jobhours=parseFloat(this.formData.i_upperhour)+parseFloat(this.formData.i_lowerhour)

                    // this.formData.f_jobhours=parseFloat(this.formData.i_upperhour)
                    // console.log(9999)

                // }else {
                    this.formData.f_jobhours=parseFloat(this.formData.i_upperhour)+parseFloat(this.formData.i_lowerhour)
                // }
                let beginTime=today+' '+this.formData.upbegintime
                let vc_upperbetween= today+' '+this.formData.vc_upperbetween;
                let endTime=today+' '+this.formData.upendtime
                if(new Date(beginTime).getTime()-new Date(endTime).getTime()>0){
                    if(parseFloat(this.formData.upendtime)<=parseFloat(this.formData.downbegintime)){
                        this.formData.i_upperstart=1
                        this.formData.i_upperend=2
                        this.formData.i_lowerstart=2
                        this.formData.i_lowerend=2
                    }
                }
            },


            changedown1(val){
                // console.log("val1",val) ;
                // console.log("beg",this.formData.downbegintime,"end",this.formData.downendtime);
                if (this.formData.downendtime){
                    this.mathuptime(2);
                }else{
                    this.formData.i_lowerhour=0;
                }
            },

            changedown2(val){
                // console.log("val2",val) ;
                // console.log("beg",this.formData.downbegintime,"end",this.formData.downendtime);
                if (this.formData.downbegintime){
                    this.mathuptime(2);
                }else{
                    this.$message.error("请先选择开始时间");
                    this.formData.downendtime="";
                    this.formData.i_lowerhour=0;
                }
            },
            changedown3(val){
                if (this.formData.downbegintime){
                    let da=this.compareTime(this.formData.downbegintime,this.formData.vc_lowerbetween);
                    if(da==1){
                        this.formData.i_lowerbetween=2;
                    }else if(da==2){
                        this.formData.i_lowerbetween=1;
                    }else{
                        this.$message.error("不能与开始时间相同");
                        this.formData.vc_lowerbetween="";
                        this.formData.i_lowerbetween=0;
                    }
                }else{
                    this.$message.error("请先选择开始时间");
                    this.formData.vc_lowerbetween="";
                    this.formData.i_lowerbetween=0;
                }
            },
            changeDKtimes(val){
              // console.log(val,"VAL")
            },



            //新增赋值
            newData(){

                this.form=this.formvalue;
                this.i_id=this.form.i_id;
                this.i_type=this.form.i_type;
                this.disabled = false;
                this.edit = false;
                this.getCompanyList();
                this.getCompanyListwt();
                this.getGroupList();
                this.getWarehouseList();
                this.getDateYYYYMMddHHMMSS();
            },

            async saveForm(){
                let add1=this.ceshi.filter(item=>{
                    return  item.name==this.formData.vc_position
                })
                this.formData.i_position=add1[0].id
                // console.log(this.formData)
                // return
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                };
                // console.log(parseFloat(this.formData.i_upperhour),'12313123')
                let param={
                   vc_bcname:this.formData.vc_bcname,
                    vc_bcnote:this.formData.vc_bcnote,
                    vc_djmark:this.formData.vc_djmark,
                    dt_upperstart:this.formData.upbegintime,
                    dt_upperend:this.formData.upendtime,
                    dt_lowerstart:this.formData.downbegintime,
                    dt_lowerend:this.formData.downendtime,
                    i_upperstart:this.formData.i_upperstart,
                    i_upperend:this.formData.i_upperend,
                    i_lowerstart:this.formData.i_lowerstart,
                    i_lowerend:this.formData.i_lowerend,
                    vc_upperbetween:this.formData.i_isfourth==1?this.formData.vc_upperbetween:null,
                    i_upperbetween:this.formData.i_isfourth==1?this.formData.i_upperbetween:null,
                    vc_lowerbetween:this.formData.i_isfourth==1?this.formData.vc_lowerbetween:null,
                    i_lowerbetween:this.formData.i_isfourth==1?this.formData.i_lowerbetween:null,
                    i_upperhour:this.formData.i_upperhour,
                    i_lowerhour:this.formData.i_lowerhour,
                    f_jobhours:this.formData.f_jobhours,
                    f_attendance:this.formData.f_attendance,
                    i_dknum:this.formData.i_dknum,
                    i_dktime:this.formData.i_dktime,
                    i_position:this.formData.i_position,
                    i_type:this.formData.i_type,
                    i_iswork:this.formData.i_iswork,
                    i_isfourth:this.formData.i_isfourth,
                    i_id:this.gaibianid,
                    vc_lruname:sessionStorage.getItem("lruname"),
                    i_setup:1,
                    i_kqtcid:this.i_kqtcid
                }
                // console.log(param)
                // return
                let res=await API.addedit(param)
                if(res.code==1){
                    this.$emit('getlist')
                    // console.log(res)
                } else if (res.code == -2) {
                    this.$router.push('/login')
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                };
            },
            // //获取岗位列表
            //
            // async positionlist(){
            //     let result = await this.getCurrentMenuId({path: this.$route.path});
            //     if (result.i_id !== "") {
            //         this.mid = result.i_id;
            //         sessionStorage.setItem('mids', result.i_id)
            //     } else {
            //         this.mid = sessionStorage.getItem('mids')
            //     };
            //
            //
            //     let param={
            //         i_uid:sessionStorage.getItem("userid")
            //     }
            //     let res=await API.positionlist(param)
            //     if(res.code==1){
            //         this.postData=res.data
            //         // this.jobhour=val[0]+val[1]
            //         console.log(res.data,11)
            //     } else if (res.code == -2) {
            //         this.$router.push('/login')
            //         this.$message.error(res.message);
            //     }else{
            //         this.$message.error(res.message);
            //     };
            // },
            taskList(data){
                // console.log("data",data);
                let val={
                    i_itype:this.i_type,
                    expanded: true,
                    data:data,
                }
                this.$emit('proDetails',val);
            },
            cancel(){

                // console.log(add1)
                // console.log(this.formData)
                this.$emit('close');
            },
            //获取当天日期
            getDateYYYYMMddHHMMSS(){
                const date = new Date();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const strDate = date.getDate().toString().padStart(2, '0');
                //return `${date.getFullYear()}-${month}-${strDate}`;
                this.formData.date=`${date.getFullYear()}-${month}-${strDate}`;
                //console.log(this.formData.date)
            },
            //得到最后一天
            getLastDay(val){
                let date=new Date(this.formData.begintime);
                date.setDate(28);
                date.setMonth(date.getMonth()+1);
                let lastDay=date.setDate(0);
                let allDay= new Date(lastDay).toString();
                const lastdate = new Date(allDay);
                const month = (lastdate.getMonth() + 1).toString().padStart(2, '0');
                const strDate = lastdate.getDate().toString().padStart(2, '0');
                //return `${date.getFullYear()}-${month}-${strDate}`;
                this.lastTime=`${lastdate.getFullYear()}-${month}-${strDate}`;
                this.$set(this.formData, "endtime",this.lastTime)
                // console.log( value)
            },
        },
    }
</script>

<style lang="scss" scoped>
    .mf{
        /*margin-left:150px;*/
    }
    .ed{
        min-width: 600px;
    }
    .flex{
        display: flex;
    }
    .item{
        width: 100%;
    }
    /deep/{
        .el-date-editor.el-input{
            width: 140px;
        }
        .num{
            margin-bottom: 12px;
        }
        .num .el-form-item__label {
            color: #b3d268;
            font-size: 16px;
            font-style: italic;
        }
        .num .el-form-item__content {
            width: 130px;
        }
        .el-tabs--border-card>.el-tabs__content{
            overflow: auto;
        }
        /*.el-table td,.el-table td, .el-table th {
            padding: 8px 0;
        }*/
        .danger-row{
            color: #999;

        }

    }


</style>